export const APPROVAL_LETTER_MAX_FILE_SIZE_KB = 5 * 1024;

export const APPROVAL_LETTER_MAX_FILE_SIZE_MB =
  APPROVAL_LETTER_MAX_FILE_SIZE_KB / 1024;

export const APPROVAL_LETTER_FILE_EXTENSIONS = ['.pdf', '.doc'];

export const APPROVAL_LETTER_ERROR_FORMAT =
  'File format not supported. Only upload .pdf, .doc.';

export const APPROVAL_LETTER_ERROR_SIZE =
  'File size exceeds the 5MB limit. Please upload a smaller file.';

export const APPROVAL_LETTER_CONSTRAINTS_DESCRIPTION = `Max file size is ${APPROVAL_LETTER_MAX_FILE_SIZE_MB}MB. Supported file types are ${APPROVAL_LETTER_FILE_EXTENSIONS.join(' and ')}`;

export function getApprovalLetterInvalidText(file: File): string {
  const filename = String(file?.name ?? '');
  const dotIndex = filename.lastIndexOf('.');
  const ext = dotIndex >= 0 ? filename.slice(dotIndex).toLowerCase() : '';
  if (!APPROVAL_LETTER_FILE_EXTENSIONS.includes(ext)) {
    return APPROVAL_LETTER_ERROR_FORMAT;
  }
  if (file.size > APPROVAL_LETTER_MAX_FILE_SIZE_KB * 1024) {
    return APPROVAL_LETTER_ERROR_SIZE;
  }
  return '';
}
